export const environment = {
    env_name: 'prod',
    prospektr_sell_backend_base_url: 'https://sell-api-homerise.prospektr.ai',
    prospektr_sell_media_url: 'https://media.propmix.io/mlslite/media/GetImageURL?fromApp=PROSPECTOR&ImageID=',
    prospektr_buy_backend_base_url: 'https://prospectorapi.propmix.io',
};